import { useAppStore } from '@/hud-bridge/store'
import { formatTime } from '@/persistence/records'

export function DefeatScreen() {
  const result = useAppStore((s) => s.lastResult)
  const setScreen = useAppStore((s) => s.setScreen)

  return (
    <div className="screen" style={{ justifyContent: 'center', alignItems: 'center' }}>
      <div className="flash-danger" />
      <div className="panel menu-enter">
        <h1 className="h1" style={{ color: 'var(--danger)' }}>
          Поражение
        </h1>
        <p className="muted">{result?.reason ?? 'Мина'}</p>
        <p style={{ fontFamily: 'var(--font-mono)', fontSize: 22 }}>
          {formatTime(result?.timeMs ?? 0)}
        </p>
        <p className="muted">
          {result?.mapName} · {result?.mode === 'exit' ? 'Exit' : 'Clear'}
        </p>
        <div className="btn-row">
          <button type="button" className="btn btn-primary" onClick={() => setScreen('loading')}>
            Restart
          </button>
          <button type="button" className="btn btn-ghost" onClick={() => setScreen('mode')}>
            Change
          </button>
          <button type="button" className="btn btn-ghost" onClick={() => setScreen('menu')}>
            Menu
          </button>
        </div>
      </div>
    </div>
  )
}

export function VictoryScreen() {
  const result = useAppStore((s) => s.lastResult)
  const setScreen = useAppStore((s) => s.setScreen)
  const title = result?.mode === 'exit' ? 'Выход' : 'Чисто'

  return (
    <div className="screen" style={{ justifyContent: 'center', alignItems: 'center' }}>
      <div className="victory-wash" />
      <div className="panel menu-enter">
        <h1 className="h1" style={{ color: 'var(--accent)' }}>
          {title}
        </h1>
        {result?.isNewRecord && (
          <p style={{ color: 'var(--safe)', fontWeight: 600 }}>New record · Local</p>
        )}
        <p style={{ fontFamily: 'var(--font-mono)', fontSize: 22, color: 'var(--safe)' }}>
          {formatTime(result?.timeMs ?? 0)}
        </p>
        {result?.previousBestMs != null && (
          <p className="muted">
            Было: {formatTime(result.previousBestMs)}
            {result.isNewRecord
              ? ` (−${formatTime(result.previousBestMs - result.timeMs)})`
              : ''}
          </p>
        )}
        <p className="muted">
          {result?.mapName} · {result?.mode === 'exit' ? 'Exit' : 'Clear'}
        </p>
        <div className="btn-row">
          <button type="button" className="btn btn-primary" onClick={() => setScreen('loading')}>
            Again
          </button>
          <button type="button" className="btn btn-ghost" onClick={() => setScreen('records')}>
            Records
          </button>
          <button type="button" className="btn btn-ghost" onClick={() => setScreen('menu')}>
            Menu
          </button>
        </div>
      </div>
    </div>
  )
}
